import Notification from '@/models/Notification'
import Api from '@/api'
import { each, find, findIndex } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {}
  },

  mutations: {
    addNotification(state, notification) {
      const exist = find(state.list, { id: notification.id })
      if (!exist) {
        state.list.unshift(new Notification(notification))
      }
    },

    setNotificationList(state, notifications) {
      each(notifications, notification => {
        const exist = find(state.list, { id: notification.id })
        if (!exist) {
          state.list.push(new Notification(notification))
        }
      })
    },

    setNotificationListMeta(state, meta) {
      state.listMeta = meta
    },

    setNotificationListItemDetails(state, notification) {
      const index = findIndex(state.list, { id: notification.id })
      state.list[index] = notification
    },

    removeNotificationItem(state, notification) {
      let index = findIndex(state.list, { id: notification.id })
      if (index !== -1) {
        state.list.splice(index, 1)
      }
    },

    clearNotificationList(state) {
      state.list = []
      state.listMeta = {}
    },

    clearNotificationListItemDetails(state, id) {
      const index = findIndex(state.list, { id: id })
      state.list.splice(index, 1)
    }
  },

  actions: {
    async getNotifications({ commit, dispatch }, params) {
      let query = Notification.page(params.page || 1)
        .custom('notifications')
        .limit(params.limit)
        .include(['notifiable', 'actor'])

      const res = await query.get(params)

      commit('setNotificationList', res.data)
      commit('setNotificationListMeta', res.meta)

      if (res.data) {
        let ids = res.data.map(notif => notif.id)
        if (ids.length) {
          dispatch('markAsRead', { notification_ids: ids })
        }
      }
    },

    async markAsRead({ commit }, formData) {
      await Api.post('notifications/mark-as-read', formData)
      commit('auth/clearUnread', null, { root: true })
    },

    async acceptRequest({ commit }, formData) {
      return Api.post(`rent-requests/${formData.id}/accept`)
    },

    async declineRequest({ commit }, formData) {
      return Api.post(`rent-requests/${formData.id}/decline`, formData)
    }
  }
}
